import {Button, Stack, Alert, Switch, IconButton, Checkbox} from '@mui/material';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment/moment';
import DocumentsModal from './DocumentsModal';
import InvoicesModal from './InvoicesModal';
import { useEffect } from 'react';
import API from '../../../../services/API';
import { Check, Close, Delete, Edit, FolderOpen, People, Receipt } from '@mui/icons-material';
import Grid from '../../../Tools/Grid';
import DpcSessionStatus from '../../../Inputs/DpcSessionStatus';
import BalanceModal from './BalanceModal';
import SynthesisModal from './SynthesisModal';


export default function SessionsTable({ actionId }){

    const [sessions, setSessions] = useState(null)
    const [status, setStatus] = useState('loading')
    const [documents, setDocuments] = useState(null)
    const [invoices, setInvoices] = useState(null)
    const [balance, setBalance] = useState(null)
    const [synthesis, setSynthesis] = useState(null)

    const columns = [
        {
            field: 'actionTitle',
            headerName: 'Action',
            width: 200,
            type: 'text',
            valueGetter: p => p.row.action.title,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'actionId',
            headerName: 'Réf Action',
            width: 130,
            type: 'text',
            valueGetter: p => p.row.action.id,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'number',
            headerName: 'Numéro',
            width: 80,
            type: 'number',
            valueGetter: p => parseFloat(p.row.number),
            renderCell: p => p.row.number,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'pi',
            headerName: 'P.I.',
            width: 60,
            type: 'boolean',
            valueGetter: p => p.row.isPi,
            renderCell: p => p.value ?
                <Check color='info'/> :
                <Close color='error'/>
        },
        {
            field: 'live',
            headerName: 'C.V.',
            width: 60,
            type: 'boolean',
            valueGetter: p => !!p.row.live,
            renderCell: p => p.value ?
                <Check color='info'/> :
                <Close color='error'/>
        },
        {
            field: 'start',
            headerName: 'Début',
            width: 120,
            type: 'date',
            valueGetter: p => new Date(p.row.start + 'T00:00:00.000Z'),
            renderCell: p => moment(p.value).format('DD/MM/YYYY'),
            aggregable: false,
            groupable: false,
        },
        {
            field: 'end',
            headerName: 'Fin',
            width: 120,
            type: 'date',
            valueGetter: p => new Date(p.row.end + 'T00:00:00.000Z'),
            renderCell: p => moment(p.value).format('DD/MM/YYYY'),
            aggregable: false,
            groupable: false,
        },
        {
            field: 'registrantsCount',
            headerName: 'Inscrits',
            width: 80,
            type: 'number',
            valueGetter: p => p.row.registrantsCount,
            renderCell: p => 
                <Button 
                    component={Link} 
                    to={`/dpc/sessions/${p.row.id}/registrations`}
                    size='small'
                    startIcon={<People />}
                >
                    {p.value.toLocaleString()}
                </Button>,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'signaturesCount',
            headerName: 'Attestations',
            width: 100,
            type: 'number',
            valueGetter: p => p.row.signaturesCount,
            renderCell: p => p.value.toLocaleString(),
            aggregable: false,
            groupable: false,
        },
        {
            field: 'revenue',
            headerName: 'Revenu',
            width: 100,
            type: 'number',
            valueGetter: p => p.row.revenue,
            renderCell: p => 
                <span>{p.value.toLocaleString()}<small>€</small></span>,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'open',
            headerName: 'Ouverte',
            width: 90,
            type: 'boolean',
            valueGetter: p => !p.row.closed,
            renderCell: p => 
                <Switch 
                    checked={p.value} 
                    onClick={() => updateSession({...p.row, closed: !p.row.closed})}
                />,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'invoiceDate',
            headerName: 'Date facture',
            width: 110,
            type: 'date',
            valueGetter: p => p.row.invoiceDate ? moment(p.row.invoiceDate).toDate() : null,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'paid',
            headerName: 'Soldé',
            headerAlign: 'center',
            width: 60,
            type: 'boolean',
            align: 'center',
            valueGetter: p => p.row.paidAt ? true : false,
            renderCell: p =>
                <Checkbox 
                    onChange={(_, value) => handleBalanceCheck(value, p.row)}
                    checked={p.value}
                    size="small"
                />,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'paidAt',
            headerName: 'Soldé le',
            width: 110,
            type: 'date',
            valueGetter: p => p.row.paidAt ? moment(p.row.paidAt).toDate() : null,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'balanceAmount',
            headerName: 'Solde €',
            width: 90,
            type: 'number',
            valueGetter: p => p.row.balanceAmount
        },
        {
            field: 'documents',
            headerName: 'Télécharger',
            width: 150,
            valueGetter: p =>  p.row.id,
            renderCell: p => 
                <Button
                    size="small"
                    startIcon={<FolderOpen />}
                    onClick={() => setDocuments(p.row)}
                >
                    Documents
                </Button>,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'invoices',
            headerName: 'Factures',
            width: 130,
            valueGetter: p =>  p.row.id,
            renderCell: p => 
                <Button
                    size="small"
                    startIcon={<Receipt />}
                    onClick={() => setInvoices(p.row)}
                >
                    Factures
                </Button>,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'synthesis',
            headerName: 'Synthèse',
            width: 110,
            valueGetter: p => p.row.id,
            renderCell: p =>
                <Button
                    size="small"
                    onClick={() => setSynthesis(p.row)}
                >
                    Synthèse
                </Button>,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'status',
            headerName: 'Demande de solde',
            width: 230,
            valueGetter: p =>  p.row.status.title,
            renderCell: p => 
                <DpcSessionStatus 
                    value={p.row.status}
                    onChange={status => updateSession({...p.row, status})}
                />,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'actions',
            headerName: '',
            width: 100,
            valueGetter: p =>  p.row.id,
            renderCell: p => 
                <Stack direction='row'>
                    <IconButton 
                        component={Link} 
                        to={`/dpc/actions/${p.row.action.id}/sessions/${p.value}`} 
                        size='small'
                    >
                        <Edit />
                    </IconButton>
                    <IconButton 
                        onClick={() => handleDelete(p.value)}
                        size='small'
                    >
                        <Delete />
                    </IconButton>
                </Stack>,
            aggregable: false,
            groupable: false,
        },
        /*{
            field: 'resetLogs',
            headerName: 'Logs',
            width: 150,
            valueGetter: p =>  p.row.id,
            renderCell: p => 
                <ResetLogs session={p.row} />,
            aggregable: false,
            groupable: false,
        },*/
    ];

    useEffect(() => {

        API.get(`/dpc/sessions`)
            .then(r => {
                setSessions(r.data)
                setStatus('ready')
            })
            .catch(() => setStatus('error'))

    }, [])
        

    const handleDelete = id => {
        const ok = window.confirm("Êtes-vous sûr de vouloir supprimer cette session ?");
        if(!ok) return false;

        API.delete(`/dpc/sessions/${id}`)
            .catch(e => {
                window.alert(e.response?.data?.error
                    || "Une session DPC ne peut être supprimée que par l'administrateur système.");
            })
    }

    const updateSession = session => {
        const oldSessions = [...sessions];
        let newSessions = [...sessions];
        
        const index = newSessions.findIndex(s => s.id === session.id);
        newSessions[index] = session;

        setSessions(newSessions)

        API.put(`/dpc/sessions/${session.id}`, session)
            .catch(e => setSessions(oldSessions))
    }

    const handleBalanceCheck = (value, session) => {
        if (value) {
            setBalance(session)
        } else {
            const ok = window.confirm("Êtes-vous sûr de vouloir effacer le solde de cette session ?");
            if (!ok) return false;
            updateSession({...session, 
                balanceAmount: 0,
                paidAt: null
            });
        }
    }

    const handleBalanceSubmit = session => {
        updateSession(session);
        setBalance(null);
    }

    const filteredSessions = sessions && actionId
        ? sessions.filter(s => String(s.action?.id) === String(actionId))
        : sessions;

    if (status === 'error') {
        return (
            <Alert severity="error">
                Une erreur s'est produite. Les données n'ont pas pu être récupérées.
            </Alert>
        );
    }

    return <>

        <Grid
            id={`dpcSessionsGrid`}
            columns={columns}
            rows={filteredSessions}
            toolbar
        />

        <DocumentsModal
            session={documents}
            onClose={() => setDocuments(null)}
        />

        <InvoicesModal
            session={invoices}
            onClose={() => setInvoices(null)}
        />

        <BalanceModal
            session={balance}
            onClose={() => setBalance(null)}
            onSubmit={handleBalanceSubmit}
        />

        <SynthesisModal
            sessionId={synthesis?.id}
            open={!!synthesis}
            onClose={() => setSynthesis(null)}
            fileName={synthesis ? `Synthese_de_suivi-${synthesis.action?.id}-${synthesis.number}.pdf` : undefined}
        />

    </>
}
